import { render, staticRenderFns } from "./ScreenLaudoTransvaginalUteroComTridimensional.vue?vue&type=template&id=f22d9cda&lang=true&"
import script from "./ScreenLaudoTransvaginalUteroComTridimensional.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalUteroComTridimensional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports